// extracted by mini-css-extract-plugin
module.exports = {"root":"counts-2_root__9HMt8","content":"counts-2_content__G41vi","item":"counts-2_item__XOYrv","title":"counts-2_title__U9nhG","description":"counts-2_description__UVAml"};